/**
 * `crypto.randomUUID` exists only in secure contexts (HTTPS or localhost).
 * Phone-on-LAN dev (`http://192.168.x.x:5173`) is insecure, so the aanvraag
 * page crashed there with "randomUUID is not a function" (user find,
 * 2026-08-21). `getRandomValues` has no such restriction, so fall back to a
 * hand-rolled v4. Production is HTTPS and always takes the native path.
 */
export function uuid(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();

  const bytes = crypto.getRandomValues(new Uint8Array(16));
  // Version and variant bits per RFC 4122 §4.4.
  bytes[6] = ((bytes[6] as number) & 0x0f) | 0x40;
  bytes[8] = ((bytes[8] as number) & 0x3f) | 0x80;
  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
